import React, { Dispatch, SetStateAction, useState } from "react";
//components
import { Row } from "components/Layout/Grid";
import Text from "components/Text";
//assets
import "./style.scss";
import { SearchAreaProps } from "./interface";
import Input from "components/Input";
import srcBtn from "img/search-icon.svg";
import cleanBtn from "img/icon-clean-search.svg";
import AddIcon from "img/add-gray-icon.svg";
import { Button } from "components/Button";
import { Visibility } from "components/Visibility";

export const SearchArea: React.FC<SearchAreaProps> = ({
  notFound,
  setNotFound,
  codeProduct,
  setCodeProduct,
  substanceProduct,
  descriptionProduct,
  currentPageProduct,
  setSubstanceProduct,
  manufacturerProduct,
  setCurrentPageProduct,
  setDescriptionProduct,
  setManufacturerProduct,
  onClearFields,
}) => {
  const searchFilterProduct = (
    descriptionProduct: string,
    codeProduct: string,
    manufacturerProduct: string,
    substanceProduct: string
  ) => {
    setDescriptionProduct(descriptionProduct);
    setCodeProduct(codeProduct);
    setManufacturerProduct(manufacturerProduct);
    setSubstanceProduct(substanceProduct);
  };

  function onEnterPressed(
    event: any,
    descriptionProduct: string,
    codeProduct: string,
    manufacturerProduct: string,
    substanceProduct: string
  ) {
    if (
      event.keyCode !== 13 ||
      (!descriptionProduct &&
        !codeProduct &&
        !manufacturerProduct &&
        !substanceProduct)
    )
      return;
    searchFilterProduct(
      descriptionProduct,
      codeProduct,
      manufacturerProduct,
      substanceProduct
    );
  }

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setValue: React.Dispatch<React.SetStateAction<string>>,
    field: string
  ) => {
    const value = e.target.value;
    setValue(value);
    setIsSearchActive((prevState) => ({
      ...prevState,
      [field]: value.length > 0,
    }));
  };

  const clearSearch = () => {
    setNotFound(false);
    searchFilterProduct("", "", "", "");
    setIsSearchActive({
      code: false,
      description: false,
      substance: false,
      manufacturer: false,
    });

    if (onClearFields) onClearFields();
  };

  const clearInput = (
    setValue: React.Dispatch<React.SetStateAction<string>>,
    field: string
  ) => {
    setValue("");
    setIsSearchActive((prevState) => ({
      ...prevState,
      [field]: false,
    }));
  };

  const [isSearchActive, setIsSearchActive] = useState({
    code: false,
    description: false,
    substance: false,
    manufacturer: false,
  });

  return (
    <Row className="flex-column w-100">
      <Row className="mt-2 mb-1 container-inputs-products w-100">
        <Row className="mb-2 flex-column">
          <Row>
            <Text
              className="title-section color-primaryViveo font-bold"
              size={12}
            >
              Cód. Produto
            </Text>
          </Row>
          <Input
            type="text"
            icon={isSearchActive.code ? cleanBtn : srcBtn}
            value={codeProduct}
            onKeyDown={(e: any) =>
              onEnterPressed(
                e,
                descriptionProduct,
                e.target.value.toLowerCase(),
                manufacturerProduct,
                substanceProduct
              )
            }
            onChange={(e) => handleInputChange(e, setCodeProduct, "code")}
            className={`h-5 bg-white search ${
              notFound ? "not-found-border" : ""
            }`}
            placeholder="Buscar código"
            onClickIcon={() => {
              clearInput(setCodeProduct, "code");
            }}
          />
        </Row>

        <Row className="ml-2 mb-2 flex-column">
          <Row>
            <Text
              className="title-section color-primaryViveo font-bold"
              size={12}
            >
              Descrição
            </Text>
          </Row>
          <Input
            type="text"
            icon={isSearchActive.description ? cleanBtn : srcBtn}
            value={descriptionProduct}
            onKeyDown={(e: any) =>
              onEnterPressed(
                e,
                e.target.value.toLowerCase(),
                codeProduct,
                manufacturerProduct,
                substanceProduct
              )
            }
            onChange={(e) =>
              handleInputChange(e, setDescriptionProduct, "description")
            }
            className={`h-5 bg-white search ${
              notFound ? "not-found-border" : ""
            }`}
            placeholder="Buscar descrição"
            onClickIcon={() => {
              clearInput(setDescriptionProduct, "description");
            }}
          />
        </Row>

        <Row className="ml-2 mb-2 flex-column">
          <Row>
            <Text
              className="title-section color-primaryViveo font-bold"
              size={12}
            >
              Substância
            </Text>
          </Row>
          <Input
            type="text"
            icon={isSearchActive.substance ? cleanBtn : srcBtn}
            value={substanceProduct}
            onKeyDown={(e: any) =>
              onEnterPressed(
                e,
                descriptionProduct,
                codeProduct,
                manufacturerProduct,
                e.target.value.toLowerCase()
              )
            }
            onChange={(e) =>
              handleInputChange(e, setSubstanceProduct, "substance")
            }
            className={`h-5 bg-white search ${
              notFound ? "not-found-border" : ""
            }`}
            placeholder="Buscar substância"
            onClickIcon={() => {
              clearInput(setSubstanceProduct, "substance");
            }}
          />
        </Row>

        <Row className="ml-2 mb-2 flex-column">
          <Row>
            <Text
              className="title-section color-primaryViveo font-bold"
              size={12}
            >
              Marca
            </Text>
          </Row>
          <Input
            type="text"
            icon={isSearchActive.manufacturer ? cleanBtn : srcBtn}
            value={manufacturerProduct}
            onKeyDown={(e: any) =>
              onEnterPressed(
                e,
                descriptionProduct,
                codeProduct,
                e.target.value.toLowerCase(),
                substanceProduct
              )
            }
            onChange={(e) =>
              handleInputChange(e, setManufacturerProduct, "manufacturer")
            }
            className={`h-5 bg-white search ${
              notFound ? "not-found-border" : ""
            }`}
            placeholder="Buscar marca"
            onClickIcon={() => {
              clearInput(setManufacturerProduct, "manufacturer");
            }}
          />
        </Row>

        <Row className="mt-3 mb-1">
          <Button onClick={() => clearSearch()}>
            <Text
              size={14}
              className="color-primary ml-3 text-decoration-underline"
            >
              Limpar campos de busca
            </Text>
          </Button>
        </Row>
      </Row>
    </Row>
  );
};
